<template>
    <div class="view view--campaigns">
        <p class="has-margin-b30">
            <strong
                v-html="
                    __(
                        'This is where you can create unique links from offline campaigns. You should not create campaigns for online events (influencer, PPC, etc.) as those will be tracked automatically.'
                    )
                "
            ></strong>
        </p>

        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <btn
            class="is-success"
            type="default"
            v-html="__('+ Add campaign')"
            v-on:click="showAddModal"
        ></btn>

        <modal
            class="is-narrow"
            v-bind:title="__('Add campaign')"
            v-bind:is-open="isOpenAddModal"
            v-on:close-modal="isOpenAddModal = false"
            v-bind:slot-props="errors"
        >
            <template v-slot:body>
                <div class="has-margin-b30">
                    <control
                        name="nameAddControl"
                        type="text"
                        v-bind:label="__('Name')"
                        v-model="addedCampaign.name"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.name != null"
                    >
                        {{ errors.name[0] }}
                    </div>
                </div>
                <div class="has-margin-b30">
                    <control
                        name="mediumAddControl"
                        type="text"
                        v-bind:label="__('Medium')"
                        v-model="addedCampaign.medium"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.medium != null"
                    >
                        {{ errors.medium[0] }}
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <btn
                    class="is-block is-success"
                    type="default"
                    v-html="__('Save')"
                    v-on:click="createdCampaign"
                ></btn>
            </template>
        </modal>

        <modal
            class="is-narrow"
            v-bind:title="__('Edit campaign')"
            v-bind:is-open="isOpenEditModal"
            v-on:close-modal="isOpenEditModal = false"
            v-bind:slot-props="errors"
        >
            <template v-slot:body>
                <div class="has-margin-b30">
                    <control
                        name="nameEditControl"
                        type="text"
                        v-bind:label="__('Name')"
                        v-model="editedCampaign.name"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.name != null"
                    >
                        {{ errors.name[0] }}
                    </div>
                </div>
                <div class="has-margin-b30">
                    <control
                        name="emailEditControl"
                        type="text"
                        v-bind:label="__('Medium')"
                        v-model="editedCampaign.medium"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.medium != null"
                    >
                        {{ errors.medium[0] }}
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <btn
                    class="is-block is-success"
                    type="default"
                    v-html="__('Save')"
                    v-on:click="updateCampaign"
                ></btn>
            </template>
        </modal>

        <modal
            class="is-narrow"
            v-bind:title="__('Are you sure?')"
            v-bind:is-open="isOpenDeleteModal"
            v-on:close-modal="isOpenDeleteModal = false"
        >
            <template v-slot:body>
                <p
                    class="has-text-center"
                    v-html="
                        __(
                            'Are you sure you want to delete this campaign?<br />This action cannot be undone.'
                        )
                    "
                ></p>
            </template>
            <template v-slot:footer>
                <div class="has-padding-t10">
                    <div class="columns">
                        <div class="column">
                            <btn
                                class="is-block"
                                type="cancel"
                                v-html="__('Cancel')"
                                v-on:click="isOpenDeleteModal = false"
                            >
                            </btn>
                        </div>
                        <div class="column">
                            <btn
                                class="is-block"
                                type="error"
                                v-html="__('Delete')"
                                v-on:click="deleteCampaign"
                            >
                            </btn>
                        </div>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';

import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import { DataTable } from '@teamfurther/cinderblock';
import { Modal } from '@teamfurther/cinderblock';
import CampaignRepository from '../../repositories/CampaignRepository';

export default {
    components: {
        Btn,
        Control,
        DataTable,
        Modal
    },
    created: function() {
        this.campaignRepository = new CampaignRepository();
    },
    data: function() {
        return {
            addedCampaign: {
                email: '',
                name: '',
                password: '',
                passwordConfirmation: '',
                role: null
            },
            campaigns: [],
            campaignRepository: null,
            deletingId: null,
            editedCampaign: {
                id: null,
                email: '',
                name: '',
                password: '',
                passwordConfirmation: '',
                role: null
            },
            errors: {},
            isOpenAddModal: false,
            isOpenDeleteModal: false,
            isOpenEditModal: false,
            tableData: {
                columnNames: {
                    name: this.__('Name'),
                    medium: this.__('Medium'),
                    url: this.__('URL'),
                    qr: this.__('QR')
                },
                items: [],
                sortableColumns: ['medium', 'name']
            }
        };
    },
    methods: {
        createdCampaign: async function() {
            try {
                await this.campaignRepository.createCampaign(
                    this.addedCampaign.medium,
                    this.addedCampaign.name
                );

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Campaign was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );
                this.isOpenAddModal = false;
                await this.getCampaigns();
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        deleteCampaign: async function() {
            try {
                await this.campaignRepository.deleteCampaign(this.deletingId);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Campaign was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await this.getCampaigns();
            } catch (error) {
            } finally {
                this.isOpenDeleteModal = false;
            }
        },
        getCampaigns: async function(sort = '') {
            try {
                this.campaigns = await this.campaignRepository.getCampaigns(
                    sort
                );

                let items = [];
                this.campaigns.forEach(campaign => {
                    items.push(this.transformCampaignData(campaign));
                });
                this.$set(this.tableData, 'items', items);
            } catch (error) {}
        },
        showAddModal: function() {
            this.addedCampaign = {
                medium: '',
                name: ''
            };

            this.isOpenAddModal = true;
        },
        showDeleteModal: function(data) {
            this.deletingId = data.id;
            this.isOpenDeleteModal = true;
        },
        showEditModal: function(data) {
            this.editedCampaign = {
                id: data.id,
                medium: data.medium,
                name: data.name
            };

            this.isOpenEditModal = true;
        },
        sortDataTable: function(sortByColumn) {
            if (
                this.tableData.sortableColumns.includes(
                    sortByColumn.replace('-', '')
                )
            ) {
                this.getCampaigns(sortByColumn);
            }
        },
        transformCampaignData: function(campaign) {
            let actions = [];

            actions.push({
                class: 'is-red',
                method: 'showDeleteModal',
                title: this.__('Delete')
            });
            actions.push({
                method: 'showEditModal',
                title: this.__('Edit')
            });

            return {
                values: {
                    id: campaign.id,
                    medium: campaign.medium,
                    name: campaign.name,
                    qr:
                        '<img style="height: 100px" src="data:image/svg+xml;base64,' +
                        campaign.qr_code +
                        '" />',
                    url: '<a href="' + campaign.link + '">Link</a>'
                },
                actions: actions
            };
        },
        updateCampaign: async function() {
            try {
                await this.campaignRepository.updateCampaign(
                    this.editedCampaign.id,
                    this.editedCampaign.medium,
                    this.editedCampaign.name
                );

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Campaign was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                this.isOpenEditModal = false;

                await this.getCampaigns();
            } catch (error) {
                this.errors = error.data.errors;
            }
        }
    },
    mounted: function() {
        this.getCampaigns();
    }
};
</script>
